import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-scroll";
import { Typography } from "@material-tailwind/react";

import sgFlag from "../../assets/sg_flag.jpg";
import SocialIcons from "../SocialIcons/SocialIcons";
import {
  SECTION_NAV_ITEMS,
  SECTION_SCROLL_OFFSET,
} from "../navigation/sectionNavConfig";
import "./Sidebar.css";

const proofPoints = ["Backend systems", "Cloud delivery"];

const SidebarLink = ({ to, label, activeSection, setActiveSection }) => (
  <Link
    to={to}
    spy={true}
    smooth="easeInQuad"
    duration={200}
    offset={SECTION_SCROLL_OFFSET}
    // onClick={() => setActiveSection(to)}
    onSetActive={() => setActiveSection(to)}
    className={`sidebar-link ${activeSection === to ? "active-link" : ""}`}
    aria-current={activeSection === to ? "true" : "false"}
  >
    {label}
  </Link>
);

SidebarLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  activeSection: PropTypes.string.isRequired,
  setActiveSection: PropTypes.func.isRequired,
};

const Sidebar = ({ reveal }) => {
  const [activeSection, setActiveSection] = useState(SECTION_NAV_ITEMS[0].to);

  return (
    <div className={`sidebar ${reveal ? "sidebar-visible" : ""}`}>
      <div className="sidebar-header">
        <Typography className="sidebar-kicker">Software engineer</Typography>
        <Typography variant="h3" className="sidebar-name">
          Zheng Ting
        </Typography>
        <Typography className="sidebar-bio">
          A Software Engineering graduate from Singapore.{" "}
          <img className="flag" src={sgFlag} alt="Singapore flag." />
        </Typography>
        <Typography className="sidebar-bio sidebar-bio-secondary">
          Building backend platforms and cloud-native products with a focus on
          reliability, delivery speed, and clean developer experience.
        </Typography>
      </div>
      <nav className="sidebar-nav">
        {SECTION_NAV_ITEMS.map((section) => (
          <SidebarLink
            key={section.to}
            to={section.to}
            label={section.label}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
          />
        ))}
      </nav>
      <div className="sidebar-proof-list" aria-label="Key proof points">
        {proofPoints.map((proofPoint) => (
          <div key={proofPoint} className="sidebar-proof-item">
            {proofPoint}
          </div>
        ))}
      </div>
      <SocialIcons />
    </div>
  );
};

Sidebar.propTypes = {
  reveal: PropTypes.bool.isRequired,
};

export default Sidebar;
